import { Grid, styled, Tooltip, Typography } from '@mui/material'
import { GridSlotsComponentsProps, useGridApiContext } from '@mui/x-data-grid-premium'

declare module '@mui/x-data-grid-premium' {
  interface FooterPropsOverrides {
    summary: React.ReactNode
  }
}

export type GridTableFooterProps = NonNullable<GridSlotsComponentsProps['footer']>

export const GridTableFooter: React.FC<GridTableFooterProps> = ({ summary }) => {
  const apiRef = useGridApiContext()
  const numSelectedRows = apiRef.current.getSelectedRows().size

  return (
    <StyledContainer container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
      <Grid item xs={4}>
        <StyledTypography variant="body2">
          {numSelectedRows > 0 && `${numSelectedRows} row${numSelectedRows > 1 ? 's' : ''} selected`}
        </StyledTypography>
      </Grid>
      <Grid item xs={8} sx={{ textAlign: 'end' }}>
        <Tooltip title={summary} placement="top-end">
          <StyledTypography variant="body2">
            {summary}
          </StyledTypography>
        </Tooltip>
      </Grid>
    </StyledContainer>
  )
}

const StyledContainer = styled(Grid)`
  height: ${({ theme }) => theme.typography.pxToRem(32)};
  padding: 0 0 0 ${({ theme }) => theme.typography.pxToRem(8)};
`

const StyledTypography = styled(Typography)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`
